import { PageView } from './PageView'
import {TermsConditionsController} from "../../Controllers/PageControllers/TermsConditionsController";
import {TermsConditionsComponent} from "../design/TermsConditionsComponent";
import {controllers} from "../../Controllers/Controller";

class TermsConditionsPage extends PageView {
    componentDidMount(){
        super.componentDidMount()
        controllers().menu.setIsBlured(true);
        controllers().menu.setIsBluredLock(true);
    }
    componentWillUnmount() {
        controllers().menu.setIsBluredLock(false);
    }
    get controller():TermsConditionsController{
        return this.props.controller
    }

    render(){
        return <div className="home page mt-100">
            <TermsConditionsComponent />
        </div>
    }
}

export { TermsConditionsPage }
